import React from 'react';
import { AppStartContextProps } from 'config/interfaces';


const initial: AppStartContextProps = {appStart: true, updateAppStart: null}
export const AppStartContext = React.createContext(initial);